import commonHelpStyles from './common-help.module.scss';
import { Button } from 'antd';
import { src } from '../../../utils/common';
import { useUserAgentInfo } from '../../../context/user-agent';
import { WebPNativeImage } from '../../WebPImage';

export default function CommonHelp(props) {
  const { icon, title, desc, hasBtn, btnDesc, onClick } = props.item;
  const { isMobile } = useUserAgentInfo();

  return (
    <div className={commonHelpStyles.helpWrapper}>
      <div className={commonHelpStyles.background}></div>
      {icon && (
        <div>
          <WebPNativeImage
            src={src(icon)}
            alt="helpIcon"
            className={commonHelpStyles.cardIcon}
          />
        </div>
      )}
      <div className={commonHelpStyles.info}>
        <div className={commonHelpStyles.title}>{title}</div>
        <div className={commonHelpStyles.desc}>
          {desc.map((item, index) => (
            <div key={index}>{item}</div>
          ))}
        </div>
        {hasBtn && (
          <div className={commonHelpStyles.subBtn}>
            <Button type="primary" ghost={isMobile} onClick={() => onClick()}>
              {btnDesc}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
